import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {api, t} from 'shared/core';
import {endpoints, types, auth} from 'main/tools';
import {serializeModel} from 'shared/store';
import {successAlert} from 'shared/tools';
import BenefitInfo from 'main/stores/benefits/BenefitInfo';

class EmployeeOnboardingState {
  store = new DomainStore();

  benefitInfo;
  onboardStep;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  receiveProps({onboardStep}) {
    this.onboardStep = onboardStep;
  }

  async load() {
    await this.store._compose([
      endpoints.BENEFIT_INFO.with(auth.employee.id)
    ]);

    this.benefitInfo = new BenefitInfo(this.store._getSingle(types.BENEFIT_INFO));
  }

  async saveBenefitInfo() {
    const {model, errors} = await this.store.patch(this.benefitInfo);
    this.errors = errors;

    if (model) {
      this.benefitInfo.update(model);
      successAlert(t('benefit_enrolment.alerts.Benefit information saved.'));
      if (this.onboardStep) {
        await this.updateOnboardingStep();
      }
    }
  }

  async updateOnboardingStep() {
    await api.patch(`employees/${auth.employee.id}/onboard`, serializeModel({step: this.onboardStep}));
    window.location = '/onboard';
  }
}

export default EmployeeOnboardingState;
